import { render, staticRenderFns } from "./ResultsNotes.vue?vue&type=template&id=09932707&scoped=true&lang=pug&"
import script from "./ResultsNotes.vue?vue&type=script&lang=js&"
export * from "./ResultsNotes.vue?vue&type=script&lang=js&"
import style0 from "./ResultsNotes.vue?vue&type=style&index=0&id=09932707&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09932707",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VTextarea})
